<template>
  <div>
    <div class="tab-pane-body-sale">
      <el-form :model="courseInfo" ref="saleInfoForm" label-position="right" label-width="112px">
        <el-form-item label="收费状态" prop="is_free">
          <el-radio-group v-model="courseInfo.is_free">
            <el-radio :label="0" border>免费</el-radio>
            <el-radio :label="1" border>收费</el-radio>  
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="courseInfo.price" :precision="2" :step="50" :max="100000000" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="划线价" prop="price">
          <el-input-number v-model="courseInfo.line_price" :precision="2" :step="200" :max="100000000" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="VIP是否免费" prop="vip_free">
          <el-radio-group v-model="courseInfo.vip_free">
            <el-radio :label="1" border>免费</el-radio>
            <el-radio :label="0" border>收费</el-radio>  
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）


export default {
  components: {

  },
  props: {
    // 课程信息
    courseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  // 定义属性
  data() {
    return {
      
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {

  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 基本信息表单验证
    formValidate() {
      this.$refs['saleInfoForm'].validate((valid) => {
        if (valid) {
          this.$emit('formSubmit',this.courseInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    }
    
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-sale
    padding 16px
    width 60%
    margin-bottom 48px
    .el-input-number
      width 100%
      .el-input__inner
        text-align left
</style>